export default {
  accounts: {
    jobs: [{
      id: 1,
      accountId: 1,
      causedById: 1,
      jobtype: "Reindex Case Template",
      jobStatus: "Completed",
      totalSteps: 10,
      currentStep: 10,
      createdAt: "2020-02-11 09:00:00"
    },
    {
      id: 2,
      accountId: 1,
      causedById: 1,
      jobtype: "Export",
      jobStatus: "Completed",
      totalSteps: 10,
      currentStep: 10,
      createdAt: "2020-02-11 10:00:00"
    },
    {
      id: 3,
      accountId: 1,
      causedById: 1,
      jobtype: "Import",
      jobStatus: "Failed",
      totalSteps: 10,
      currentStep: 7,
      createdAt: "2020-02-11 11:00:00"
    },
    {
      id: 4,
      accountId: 1,
      causedById: 1,
      jobtype: "Export",
      jobStatus: "Running",
      totalSteps: 10,
      currentStep: 2,
      createdAt: "2020-02-11 12:00:00"
    },
    {
      id: 5,
      accountId: 1,
      causedById: 1,
      jobtype: "Reindex Case Template",
      jobStatus: "Pending",
      totalSteps: 10,
      currentStep: 0,
      createdAt: "2020-02-11 13:00:00"
    }
    ]
  },
  currentUser: {
    id: 1,
    email: "testAdmin@emergeAdapt.local",
    displayName: "Test Admin",
    login: "test-admin",
    lastSeen: "",
    createdAt: "",
    updatedAt: "",
    authenticationToken: "TEST01010101TEST",
    isAccountAdmin: true,
    isBot: false,
    avatarUrl: "/",
    bookmarks: [],
    screenLayouts: [{
      id: 1,
      type: "caseHistory",
      label: "Case History",
      position: 2
    },
    {
      id: 2,
      type: "notifications",
      label: "Notifications",
      position: 1
    },
    {
      id: 3,
      type: "tasks",
      label: "Tasks",
      position: 1,
      link: "/",
      taskCount: "23",
      tasksOverdue: "2"
    },
    {
      id: 4,
      type: "bucketGroup",
      label: "Bucket Group",
      bucketGroupId: 1,
      position: 3
    }
    ],
    notifications: [{
      id: 1,
      caseId: 23,
      eventType: "case.created",
      link: "/",
      linkText: "View case",
      title: "Case XYZ status changed from X to Y",
      message: "",
      casedById: 1,
      casedBy: "Tester",
      severity: "info",
      createdAt: "2020-02-12 00:09:00"
    },
    {
      id: 2,
      caseId: 23,
      eventType: "case.read",
      link: "/",
      linkText: "View file",
      title: "Claim.pdf added to Case #2323",
      message: "",
      casedById: 1,
      casedBy: "Tester",
      severity: "info",
      createdAt: "2020-02-12 00:10:00"
    },
    {
      id: 3,
      caseId: 23,
      eventType: "case.read",
      link: "/",
      linkText: "View case",
      title: "Viewed TestCase 23",
      message: "Test Notification Message",
      casedById: 1,
      casedBy: "Tester",
      severity: "error",
      createdAt: "2020-02-12 00:11:00"
    },
    {
      id: 5,
      caseId: 23,
      eventType: "case.read",
      link: "/",
      linkText: "View Case",
      title: "Viewed TestCase 23",
      message: "Test Notification Message",
      casedById: 1,
      casedBy: "Tester",
      severity: "warn",
      createdAt: "2020-02-13 00:13:00"
    },
    {
      id: 6,
      caseId: 23,
      eventType: "case.read",
      link: "/",
      linkText: "View Case",
      title: "Viewed TestCase 23",
      message: "Test Notification Message",
      casedById: 1,
      casedBy: "Tester",
      severity: "info",
      createdAt: "2020-02-13 00:14:00"
    },

    {
      id: 9,
      caseId: 23,
      eventType: "export_started",
      link: "/",
      linkText: "View Case",
      title: "Export Started",
      message: "Test Notification Message",
      casedById: 1,
      casedBy: "Tester",
      severity: "info",
      createdAt: "2020-02-14 00:15:00"
    },
    {
      id: 10,
      caseId: 23,
      eventType: "error",
      link: "/",
      linkText: "View Case",
      title: "Case in breach shortly",
      message: "",
      casedById: 1,
      casedBy: "Tester",
      severity: "warn",
      createdAt: "2020-02-14 00:16:00"
    },
    {
      id: 10,
      caseId: 23,
      eventType: "error",
      link: "/",
      linkText: "View Case",
      title: "Call client task overdue",
      message: "Test Notification Message",
      casedById: 1,
      casedBy: "Tester",
      severity: "error",
      createdAt: "2020-02-14 00:16:00"
    }
    ],
    subscriptions: [{
      id: 1,
      case: {
        id: 123,
        title: "Case #23232",
        caseType: "Claim",
        caseTypeId: 3,
        currentState: "Processing"
      },
      eventCategory: "case-event",
      eventType: "case.created"
    },
    {
      id: 2,
      case: {
        id: 2,
        title: "Jonathan Bean",
        caseType: "Complaint",
        caseTypeId: 3,
        currentState: "Reviewing"
      },
      eventCategory: "case-event",
      eventType: "case.updated"
    },
    {
      id: 3,
      case: {
        id: 3,
        title: "Test 123",
        caseType: "Test",
        caseTypeId: 3,
        currentState: "Testing"
      },
      eventCategory: "case-event",
      eventType: "case.read"
    }
    ],
    teams: [{
      id: 1,
      displayName: "Alpha"
    },
    {
      id: 2,
      displayName: "Beta"
    },
    {
      id: 3,
      displayName: "Gamma"
    },
    {
      id: 4,
      displayName: "Delta"
    },
    {
      id: 5,
      displayName: "Epsilon"
    },
    {
      id: 6,
      displayName: "Zeta"
    }
    ],
    account: {
      id: 1,
      title: "TESTAC",
      nickname: "Tester",
      users: [{
        id: 1,
        login: "primo",
        displayName: "Primo",
        email: "primo@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 1,
          displayName: "Alpha"
        }]
      },
      {
        id: 2,
        login: "secondo",
        displayName: "Secondo",
        email: "secondo@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 1,
          displayName: "Alpha"
        }]
      },
      {
        id: 3,
        login: "terzo",
        displayName: "Terzo",
        email: "terzo@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 2,
          displayName: "Beta"
        }]
      },
      {
        id: 4,
        login: "quarto",
        displayName: "Quarto",
        email: "quarto@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 2,
          displayName: "Beta"
        }]
      },
      {
        id: 5,
        login: "quinto",
        displayName: "Quinto",
        email: "quinto@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 3,
          displayName: "Gamma"
        }]
      },
      {
        id: 6,
        login: "sesto",
        displayName: "Sesto",
        email: "sesto@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 4,
          displayName: "Delta"
        }]
      },
      {
        id: 7,
        login: "settimo",
        displayName: "Settimo",
        email: "settimo@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 4,
          displayName: "Delta"
        }]
      },
      {
        id: 8,
        login: "ottavo",
        displayName: "Ottavo",
        email: "ottavo@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 4,
          displayName: "Delta"
        }]
      },
      {
        id: 9,
        login: "nono",
        displayName: "Nono",
        email: "nono@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 5,
          displayName: "Epsilon"
        }]
      },
      {
        id: 10,
        login: "decimo",
        displayName: "Decimo",
        email: "decimo@users.com",
        lastSeen: "019-09-07T18:02:31:000Z",
        teams: [{
          id: 5,
          displayName: "Epsilon"
        }]
      }
      ],
      teams: [{
        id: 1,
        displayName: "Alpha"
      },
      {
        id: 2,
        displayName: "Beta"
      },
      {
        id: 3,
        displayName: "Gamma"
      },
      {
        id: 4,
        displayName: "Delta"
      },
      {
        id: 5,
        displayName: "Epsilon"
      },
      {
        id: 6,
        displayName: "Zeta"
      }
      ],
      caseTypes: [{
        id: 1,
        name: "Case",
        code: "case",
        description: "First CaseType",
        displayName: "Case",
        iconCode: "file",
        iconSet: "fal",
        displayFields: [{
          id: 1,
          fieldset: "Case Details",
          fieldName: "name",
          position: 0
        },
        {
          id: 2,
          fieldset: "Case Content",
          fieldName: "description",
          position: 1
        },
        {
          id: 3,
          fieldset: "Case Content",
          fieldName: "total",
          position: 2
        }
        ],
        buckets: [{
          id: 1,
          default: true,
          description: "All",
          kpi: "current_state",
          name: "All Cases"
        }],
        bucketGroups: [{
          id: 1,
          name: "Test Bucket",
          buckets: [{
            id: 1,
            default: true,
            description: "All",
            kpi: "current_state",
            name: "All Cases",
            caseTypeName: "Claim",
            contents: {
              statistics: {
                total: 10
              }
            }
          },
          {
            id: 2,
            default: false,
            description: "Started",
            kpi: "current_state",
            name: "Started Cases",
            caseTypeName: "Order",
            contents: {
              statistics: {
                total: 210
              }
            }
          },
          {
            id: 3,
            default: false,
            description: "Awaiting Action",
            kpi: "current_state",
            name: "Pending Cases",
            caseTypeName: "Complaint",
            contents: {
              statistics: {
                total: 210
              }
            }
          },
          {
            id: 4,
            default: false,
            description: "Complete",
            kpi: "current_state",
            name: "Complete Healthcase Cases",
            caseTypeName: "Enquiry",
            contents: {
              statistics: {
                total: 1210
              }
            }
          },
          {
            id: 5,
            default: false,
            description: "Rejected",
            kpi: "current_state",
            name: "Rejected Cases",
            caseTypeName: "Claim",
            contents: {
              statistics: {
                total: 13242
              }
            }
          }
          ]
        }],
        currentSchema: {
          fieldsets: [{
            name: "Case Details",
            fields: [{
              name: "Name",
              type: "string"
            }, {
              name: "Reference",
              type: "number"
            }, {
              name: "Created At",
              type: "Date"
            }]
          },
          {
            name: "Case Content",
            fields: [{
              name: "Descriptionf",
              type: "string"
            }, {
              name: "Total",
              type: "number"
            }, {
              name: "Last Update",
              type: "Date"
            }, {
              name: "Reason",
              type: "string"
            }, {
              name: "Version",
              type: "number"
            }, {
              name: "Contact",
              type: "string"
            }]
          }
          ]
        },
        permissions: [{
          id: 1,
          permissionFlag: "yes",
          resource: {
            id: 1,
            name: "Access",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 2,
          permissionFlag: "no",
          resource: {
            id: 2,
            name: "Conversations",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 3,
          permissionFlag: "w",
          resource: {
            id: 3,
            name: "internal_references",
            permissionType: "read_write_hidden",
            resourceType: "case"
          }
        },
        {
          id: 4,
          permissionFlag: "r",
          resource: {
            id: 4,
            name: "Test",
            permissionType: "read_write_hidden",
            resourceType: "tasklist"
          }
        }
        ],
        resources: [{
          id: 1,
          name: "Access",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 2,
          name: "Conversations",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 3,
          name: "Create",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 4,
          name: "internal_references",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 5,
          name: "Test",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'tasklist'
        }
        ],
        relationships: [],
        statuses: [{
          id: 1,
          position: 0,
          state: "New"
        },
        {
          id: 2,
          position: 1,
          state: "Processing"
        },
        {
          id: 3,
          position: 2,
          state: "Ready for Review"
        },
        {
          id: 4,
          position: 3,
          state: "Accepted"
        },
        {
          id: 5,
          position: 4,
          state: "Rejected"
        }
        ],
        scripts: [{
          id: 1,
          createdAt: "2019-08-26T13:02:31:000Z",
          updatedAt: "2019-08-26T13:02:31:000Z",
          name: "Case-Script-01",
          description: "Test-001",
          reusable: false,
          isMicroservice: false,
          draftCode: "/",
          draftDocument: '{"title":"Test1"}',
          publishedCode: "exit(payload);"
        }],
        emailTemplates: [{
          id: 1,
          name: "TestMail",
          template: "---",
          category: "Email",
          updatedAt: "2019-08-26T13:02:31:000Z"
        }],
        tasklistTemplates: [{
          id: 1,
          name: "Default Tasklist",
          position: 0,
          tasks: [{
            id: 1,
            description: "Test",
            guidance: "test",
            key: "new-test-task",
            actionType: "",
            actionDefinition: ""
          }]
        }],
        teams: []
      },
      {
        id: 2,
        name: "Block",
        code: "block",
        description: "Second CaseType",
        displayName: "Block",
        iconCode: "box-open",
        iconSet: "fal",
        displayFields: [{
          id: 1,
          fieldset: "Block Details",
          fieldName: "Name",
          position: 0
        },
        {
          id: 2,
          fieldset: "Block Content",
          fieldName: "Description",
          position: 1
        },
        {
          id: 3,
          fieldset: "Block Content",
          fieldName: "Total",
          position: 2
        }
        ],
        buckets: [{
          id: 1,
          default: true,
          description: "All",
          kpi: "current_state",
          name: "All Blocks",
          number: "45",
          template: "Claims"
        }],
        bucketGroups: [],
        currentSchema: {
          fieldsets: [{
            name: "Block Details",
            fields: [{
              name: "Name",
              type: "string"
            }, {
              name: "Reference",
              type: "number"
            }, {
              name: "Created At",
              type: "Date"
            }]
          },
          {
            name: "Block Content",
            fields: [{
              name: "Description",
              type: "string"
            }, {
              name: "Total",
              type: "number"
            }, {
              name: "Last Update",
              type: "Date"
            }, {
              name: "Reason",
              type: "string"
            }, {
              name: "Version",
              type: "number"
            }, {
              name: "Contact",
              type: "string"
            }]
          }
          ]
        },
        permissions: [{
          id: 1,
          permissionFlag: "yes",
          resource: {
            id: 1,
            name: "Access",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 2,
          permissionFlag: "no",
          resource: {
            id: 2,
            name: "Conversations",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 3,
          permissionFlag: "w",
          resource: {
            id: 3,
            name: "internal_references",
            permissionType: "read_write_hidden",
            resourceType: "case"
          }
        },
        {
          id: 4,
          permissionFlag: "r",
          resource: {
            id: 4,
            name: "Test",
            permissionType: "read_write_hidden",
            resourceType: "tasklist"
          }
        }
        ],
        resources: [{
          id: 1,
          name: "Access",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 2,
          name: "Conversations",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 3,
          name: "Create",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 4,
          name: "internal_references",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 5,
          name: "Test",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'tasklist'
        }
        ],
        relationships: [],
        statuses: [{
          id: 1,
          position: 0,
          state: "New"
        },
        {
          id: 2,
          position: 1,
          state: "Gathering"
        },
        {
          id: 3,
          position: 2,
          state: "Collected for Review"
        },
        {
          id: 4,
          position: 3,
          state: "Full"
        },
        {
          id: 5,
          position: 4,
          state: "Restart"
        }
        ],
        scripts: [{
          id: 1,
          createdAt: "2019-08-26T13:02:31:000Z",
          updatedAt: "2019-08-26T13:02:31:000Z",
          name: "Block-Script-01",
          description: "Test-001",
          reusable: false,
          isMicroservice: false,
          draftCode: "/",
          draftDocument: '{"title":"Test1"}',
          publishedCode: "exit(payload);"
        }],
        emailTemplates: [{
          id: 1,
          name: "TestMail",
          template: "---",
          category: "Email",
          updatedAt: "2019-08-26T13:02:31:000Z"
        }],
        tasklistTemplates: [{
          id: 1,
          name: "Default Tasklist",
          position: 0,
          tasks: [{
            id: 1,
            description: "Test",
            guidance: "test",
            key: "new-test-task",
            actionType: "",
            actionDefinition: ""
          }]
        }],
        teams: []
      },
      {
        id: 3,
        name: "Test",
        code: "test",
        description: "Third CaseType",
        displayName: "Test",
        iconCode: "tools",
        iconSet: "fal",
        displayFields: [{
          id: 1,
          fieldset: "Test Details",
          fieldName: "Name",
          position: 0
        },
        {
          id: 2,
          fieldset: "Test Content",
          fieldName: "Description",
          position: 1
        },
        {
          id: 3,
          fieldset: "Test Content",
          fieldName: "Total",
          position: 2
        }
        ],
        buckets: [{
          id: 1,
          default: true,
          description: "All",
          kpi: "current_state",
          name: "All Tests"
        }],
        bucketGroups: [],
        currentSchema: {
          fieldsets: [{
            name: "Test Details",
            fields: [{
              name: "Name",
              type: "string"
            }, {
              name: "Reference",
              type: "number"
            }, {
              name: "Created At",
              type: "Date"
            }]
          },
          {
            name: "Test Content",
            fields: [{
              name: "Description",
              type: "string"
            }, {
              name: "Total",
              type: "number"
            }, {
              name: "Last Update",
              type: "Date"
            }, {
              name: "Reason",
              type: "string"
            }, {
              name: "Version",
              type: "number"
            }, {
              name: "Contact",
              type: "string"
            }]
          }
          ]
        },
        permissions: [{
          id: 1,
          permissionFlag: "yes",
          resource: {
            id: 1,
            name: "Access",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 2,
          permissionFlag: "no",
          resource: {
            id: 2,
            name: "Conversations",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 3,
          permissionFlag: "w",
          resource: {
            id: 3,
            name: "internal_references",
            permissionType: "read_write_hidden",
            resourceType: "case"
          }
        },
        {
          id: 4,
          permissionFlag: "r",
          resource: {
            id: 4,
            name: "Test",
            permissionType: "read_write_hidden",
            resourceType: "tasklist"
          }
        }
        ],
        resources: [{
          id: 1,
          name: "Access",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 2,
          name: "Conversations",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 3,
          name: "Create",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 4,
          name: "internal_references",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 5,
          name: "Test",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'tasklist'
        }
        ],
        relationships: [],
        statuses: [{
          id: 1,
          position: 0,
          state: "Started"
        },
        {
          id: 2,
          position: 1,
          state: "Failed"
        },
        {
          id: 3,
          position: 2,
          state: "Success"
        },
        {
          id: 4,
          position: 3,
          state: "Ready to Deploy"
        }
        ],
        scripts: [{
          id: 1,
          createdAt: "2019-08-26T13:02:31:000Z",
          updatedAt: "2019-08-26T13:02:31:000Z",
          name: "Test-Script-01",
          description: "Test-001",
          reusable: false,
          isMicroservice: false,
          draftCode: "/",
          draftDocument: '{"title":"Test1"}',
          publishedCode: "exit(payload);"
        }],
        emailTemplates: [{
          id: 1,
          name: "TestMail",
          template: "---",
          category: "Email",
          updatedAt: "2019-08-26T13:02:31:000Z"
        }],
        tasklistTemplates: [{
          id: 1,
          name: "Default Tasklist",
          position: 0,
          tasks: [{
            id: 1,
            description: "Test",
            guidance: "test",
            key: "new-test-task",
            actionType: "",
            actionDefinition: ""
          }]
        }],
        teams: []
      },
      {
        id: 4,
        name: "Customer",
        code: "customer",
        description: "Forth CaseType",
        displayName: "Customer",
        iconCode: "user-tie",
        iconSet: "fal",
        displayFields: [{
          id: 1,
          fieldset: "Customer Details",
          fieldName: "Name",
          position: 0
        },
        {
          id: 2,
          fieldset: "Customer Content",
          fieldName: "Description",
          position: 1
        },
        {
          id: 3,
          fieldset: "Customer Content",
          fieldName: "Total",
          position: 2
        }
        ],
        buckets: [{
          id: 1,
          default: true,
          description: "All",
          kpi: "current_state",
          name: "All Customers"
        }],
        bucketGroups: [],
        currentSchema: {
          fieldsets: [{
            name: "Customer Details",
            fields: [{
              name: "Name",
              type: "string"
            }, {
              name: "Reference",
              type: "number"
            }, {
              name: "Created At",
              type: "Date"
            }]
          },
          {
            name: "Customer Content",
            fields: [{
              name: "Description",
              type: "string"
            }, {
              name: "Total",
              type: "number"
            }, {
              name: "Last Update",
              type: "Date"
            }, {
              name: "Reason",
              type: "string"
            }, {
              name: "Version",
              type: "number"
            }, {
              name: "Contact",
              type: "string"
            }]
          }
          ]
        },
        permissions: [{
          id: 1,
          permissionFlag: "yes",
          resource: {
            id: 1,
            name: "Access",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 2,
          permissionFlag: "no",
          resource: {
            id: 2,
            name: "Conversations",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 3,
          permissionFlag: "w",
          resource: {
            id: 3,
            name: "internal_references",
            permissionType: "read_write_hidden",
            resourceType: "case"
          }
        },
        {
          id: 4,
          permissionFlag: "r",
          resource: {
            id: 4,
            name: "Test",
            permissionType: "read_write_hidden",
            resourceType: "tasklist"
          }
        }
        ],
        resources: [{
          id: 1,
          name: "Access",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 2,
          name: "Conversations",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 3,
          name: "Create",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 4,
          name: "internal_references",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 5,
          name: "Test",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'tasklist'
        }
        ],
        relationships: [],
        statuses: [{
          id: 1,
          position: 0,
          state: "New"
        },
        {
          id: 2,
          position: 1,
          state: "Active"
        },
        {
          id: 3,
          position: 2,
          state: "Inactive"
        }
        ],
        scripts: [{
          id: 1,
          createdAt: "2019-08-26T13:02:31:000Z",
          updatedAt: "2019-08-26T13:02:31:000Z",
          name: "Customer-Script-01",
          description: "Test-001",
          reusable: false,
          isMicroservice: false,
          draftCode: "/",
          draftDocument: '{"title":"Test1"}',
          publishedCode: "exit(payload);"
        }],
        emailTemplates: [{
          id: 1,
          name: "TestMail",
          template: "---",
          category: "Email",
          updatedAt: "2019-08-26T13:02:31:000Z"
        }],
        tasklistTemplates: [{
          id: 1,
          name: "Default Tasklist",
          position: 0,
          tasks: [{
            id: 1,
            description: "Test",
            guidance: "test",
            key: "new-test-task",
            actionType: "",
            actionDefinition: ""
          }]
        }],
        teams: []
      },
      {
        id: 5,
        name: "Supplier",
        code: "supplier",
        description: "Fifth CaseType",
        displayName: "Supplier",
        iconCode: "person-carry",
        iconSet: "fal",
        displayFields: [{
          id: 1,
          fieldset: "Supplier Details",
          fieldName: "Name",
          position: 0
        },
        {
          id: 2,
          fieldset: "Supplier Content",
          fieldName: "Description",
          position: 1
        },
        {
          id: 3,
          fieldset: "Supplier Content",
          fieldName: "Total",
          position: 2
        }
        ],
        buckets: [{
          id: 1,
          default: true,
          description: "All",
          kpi: "current_state",
          name: "All Suppliers"
        }],
        bucketGroups: [],
        currentSchema: {
          fieldsets: [{
            name: "Supplier Details",
            fields: [{
              name: "Name",
              type: "string"
            }, {
              name: "Reference",
              type: "number"
            }, {
              name: "Created At",
              type: "Date"
            }]
          },
          {
            name: "Supplier Content",
            fields: [{
              name: "Description",
              type: "string"
            }, {
              name: "Total",
              type: "number"
            }, {
              name: "Last Update",
              type: "Date"
            }, {
              name: "Reason",
              type: "string"
            }, {
              name: "Version",
              type: "number"
            }, {
              name: "Contact",
              type: "string"
            }]
          }
          ]
        },
        permissions: [{
          id: 1,
          permissionFlag: "yes",
          resource: {
            id: 1,
            name: "Access",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 2,
          permissionFlag: "no",
          resource: {
            id: 2,
            name: "Conversations",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 3,
          permissionFlag: "w",
          resource: {
            id: 3,
            name: "internal_references",
            permissionType: "read_write_hidden",
            resourceType: "case"
          }
        },
        {
          id: 4,
          permissionFlag: "r",
          resource: {
            id: 4,
            name: "Test",
            permissionType: "read_write_hidden",
            resourceType: "tasklist"
          }
        }
        ],
        resources: [{
          id: 1,
          name: "Access",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 2,
          name: "Conversations",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 3,
          name: "Create",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 4,
          name: "internal_references",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 5,
          name: "Test",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'tasklist'
        }
        ],
        relationships: [],
        statuses: [{
          id: 1,
          position: 0,
          state: "New"
        },
        {
          id: 2,
          position: 1,
          state: "Active"
        },
        {
          id: 3,
          position: 2,
          state: "Inactive"
        }
        ],
        scripts: [{
          id: 1,
          createdAt: "2019-08-26T13:02:31:000Z",
          updatedAt: "2019-08-26T13:02:31:000Z",
          name: "Supplier-Script-01",
          description: "Test-001",
          reusable: false,
          isMicroservice: false,
          draftCode: "/",
          draftDocument: '{"title":"Test1"}',
          publishedCode: "exit(payload);"
        }],
        emailTemplates: [{
          id: 1,
          name: "TestMail",
          template: "---",
          category: "Email",
          updatedAt: "2019-08-26T13:02:31:000Z"
        }],
        tasklistTemplates: [{
          id: 1,
          name: "Default Tasklist",
          position: 0,
          tasks: [{
            id: 1,
            description: "Test",
            guidance: "test",
            key: "new-test-task",
            actionType: "",
            actionDefinition: ""
          }]
        }],
        teams: []
      },
      {
        id: 6,
        name: "Product",
        code: "product",
        description: "Sixth CaseType",
        displayName: "Product",
        iconCode: "boxes",
        iconSet: "fal",
        displayFields: [{
          id: 1,
          fieldset: "Product Details",
          fieldName: "Name",
          position: 0
        },
        {
          id: 2,
          fieldset: "Product Content",
          fieldName: "Description",
          position: 1
        },
        {
          id: 3,
          fieldset: "Product Content",
          fieldName: "Total",
          position: 2
        }
        ],
        buckets: [{
          id: 1,
          default: true,
          description: "All",
          kpi: "current_state",
          name: "All Products"
        }],
        bucketGroups: [],
        currentSchema: {
          fieldsets: [{
            name: "Product Details",
            fields: [{
              name: "Name",
              type: "string"
            }, {
              name: "Reference",
              type: "number"
            }, {
              name: "Created At",
              type: "Date"
            }]
          },
          {
            name: "Product Content",
            fields: [{
              name: "Description",
              type: "string"
            }, {
              name: "Total",
              type: "number"
            }, {
              name: "Last Update",
              type: "Date"
            }, {
              name: "Reason",
              type: "string"
            }, {
              name: "Version",
              type: "number"
            }, {
              name: "Contact",
              type: "string"
            }]
          }
          ]
        },
        permissions: [{
          id: 1,
          permissionFlag: "yes",
          resource: {
            id: 1,
            name: "Access",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 2,
          permissionFlag: "no",
          resource: {
            id: 2,
            name: "Conversations",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 3,
          permissionFlag: "w",
          resource: {
            id: 3,
            name: "internal_references",
            permissionType: "read_write_hidden",
            resourceType: "case"
          }
        },
        {
          id: 4,
          permissionFlag: "r",
          resource: {
            id: 4,
            name: "Test",
            permissionType: "read_write_hidden",
            resourceType: "tasklist"
          }
        }
        ],
        resources: [{
          id: 1,
          name: "Access",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 2,
          name: "Conversations",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 3,
          name: "Create",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 4,
          name: "internal_references",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 5,
          name: "Test",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'tasklist'
        }
        ],
        relationships: [],
        statuses: [{
          id: 1,
          position: 0,
          state: "Reordering"
        },
        {
          id: 2,
          position: 1,
          state: "Sale"
        },
        {
          id: 3,
          position: 2,
          state: "Empty"
        },
        {
          id: 4,
          position: 3,
          state: "Special"
        }
        ],
        scripts: [{
          id: 1,
          createdAt: "2019-08-26T13:02:31:000Z",
          updatedAt: "2019-08-26T13:02:31:000Z",
          name: "Product-Script-01",
          description: "Test-001",
          reusable: false,
          isMicroservice: false,
          draftCode: "/",
          draftDocument: '{"title":"Test1"}',
          publishedCode: "exit(payload);"
        }],
        emailTemplates: [{
          id: 1,
          name: "TestMail",
          template: "---",
          category: "Email",
          updatedAt: "2019-08-26T13:02:31:000Z"
        }],
        tasklistTemplates: [{
          id: 1,
          name: "Default Tasklist",
          position: 0,
          tasks: [{
            id: 1,
            description: "Test",
            guidance: "test",
            key: "new-test-task",
            actionType: "",
            actionDefinition: ""
          }]
        }],
        teams: []
      },
      {
        id: 7,
        name: "Courier",
        code: "courier",
        description: "Seventh CaseType",
        displayName: "Courier",
        iconCode: "envelope",
        iconSet: "fal",
        displayFields: [],
        buckets: [{
          id: 1,
          default: true,
          description: "All",
          kpi: "current_state",
          name: "All Couriers"
        }],
        bucketGroups: [],
        currentSchema: {
          fieldsets: [{
            name: "Courier Details",
            fields: [{
              name: "Name",
              type: "string"
            }, {
              name: "Reference",
              type: "number"
            }, {
              name: "Created At",
              type: "Date"
            }]
          },
          {
            name: "Courier Content",
            fields: [{
              name: "Description",
              type: "string"
            }, {
              name: "Total",
              type: "number"
            }, {
              name: "Last Update",
              type: "Date"
            }, {
              name: "Reason",
              type: "string"
            }, {
              name: "Version",
              type: "number"
            }, {
              name: "Contact",
              type: "string"
            }]
          }
          ]
        },
        permissions: [{
          id: 1,
          permissionFlag: "yes",
          resource: {
            id: 1,
            name: "Access",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 2,
          permissionFlag: "no",
          resource: {
            id: 2,
            name: "Conversations",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 3,
          permissionFlag: "w",
          resource: {
            id: 3,
            name: "internal_references",
            permissionType: "read_write_hidden",
            resourceType: "case"
          }
        },
        {
          id: 4,
          permissionFlag: "r",
          resource: {
            id: 4,
            name: "Test",
            permissionType: "read_write_hidden",
            resourceType: "tasklist"
          }
        }
        ],
        resources: [{
          id: 1,
          name: "Access",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 2,
          name: "Conversations",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 3,
          name: "Create",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 4,
          name: "internal_references",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 5,
          name: "Test",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'tasklist'
        }
        ],
        relationships: [],
        statuses: [{
          id: 1,
          position: 0,
          state: "In Training"
        },
        {
          id: 2,
          position: 1,
          state: "Deliverying"
        },
        {
          id: 3,
          position: 2,
          state: "Awaiting Orders"
        },
        {
          id: 4,
          position: 3,
          state: "Offline"
        },
        {
          id: 5,
          position: 4,
          state: "Dismissed"
        }
        ],
        scripts: [{
          id: 1,
          createdAt: "2019-08-26T13:02:31:000Z",
          updatedAt: "2019-08-26T13:02:31:000Z",
          name: "Courier-Script-01",
          description: "Test-001",
          reusable: false,
          isMicroservice: false,
          draftCode: "/",
          draftDocument: '{"title":"Test1"}',
          publishedCode: "exit(payload);"
        }],
        emailTemplates: [{
          id: 1,
          name: "TestMail",
          template: "---",
          category: "Email",
          updatedAt: "2019-08-26T13:02:31:000Z"
        }],
        tasklistTemplates: [{
          id: 1,
          name: "Default Tasklist",
          position: 0,
          tasks: [{
            id: 1,
            description: "Test",
            guidance: "test",
            key: "new-test-task",
            actionType: "",
            actionDefinition: ""
          }]
        }],
        teams: []
      },
      {
        id: 8,
        name: "Order",
        code: "order",
        description: "Eighth CaseType",
        displayName: "Order",
        iconCode: "shopping-basket",
        iconSet: "fal",
        displayFields: [],
        buckets: [{
          id: 1,
          default: true,
          description: "All",
          kpi: "current_state",
          name: "All Orders"
        }],
        bucketGroups: [],
        currentSchema: {
          fieldsets: [{
            name: "Order Details",
            fields: [{
              name: "Name",
              type: "string"
            }, {
              name: "Reference",
              type: "number"
            }, {
              name: "Created At",
              type: "Date"
            }]
          },
          {
            name: "Order Content",
            fields: [{
              name: "Description",
              type: "string"
            }, {
              name: "Total",
              type: "number"
            }, {
              name: "Last Update",
              type: "Date"
            }, {
              name: "Reason",
              type: "string"
            }, {
              name: "Version",
              type: "number"
            }, {
              name: "Contact",
              type: "string"
            }]
          }
          ]
        },
        permissions: [{
          id: 1,
          permissionFlag: "yes",
          resource: {
            id: 1,
            name: "Access",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 2,
          permissionFlag: "no",
          resource: {
            id: 2,
            name: "Conversations",
            permissionType: "yes_no",
            resourceType: "case"
          }
        },
        {
          id: 3,
          permissionFlag: "w",
          resource: {
            id: 3,
            name: "internal_references",
            permissionType: "read_write_hidden",
            resourceType: "case"
          }
        },
        {
          id: 4,
          permissionFlag: "r",
          resource: {
            id: 4,
            name: "Test",
            permissionType: "read_write_hidden",
            resourceType: "tasklist"
          }
        }
        ],
        resources: [{
          id: 1,
          name: "Access",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 2,
          name: "Conversations",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 3,
          name: "Create",
          permissionType: "yes_no",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 4,
          name: "internal_references",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'case'
        },
        {
          id: 5,
          name: "Test",
          permissionType: "read_write_hidden",
          permissions: null,
          resourceType: 'tasklist'
        }
        ],
        relationships: [],
        statuses: [{
          id: 1,
          position: 0,
          state: "New"
        },
        {
          id: 2,
          position: 1,
          state: "Ready"
        },
        {
          id: 3,
          position: 2,
          state: "Complete"
        },
        {
          id: 4,
          position: 3,
          state: "Refund"
        },
        {
          id: 5,
          position: 4,
          state: "incomplete"
        }
        ],
        scripts: [{
          id: 1,
          createdAt: "2019-08-26T13:02:31:000Z",
          updatedAt: "2019-08-26T13:02:31:000Z",
          name: "Order-Script-01",
          description: "Test-001",
          reusable: false,
          isMicroservice: false,
          draftCode: "/",
          draftDocument: '{"title":"Test1"}',
          publishedCode: "exit(payload);"
        }],
        emailTemplates: [{
          id: 1,
          name: "TestMail",
          template: "---",
          category: "Email",
          updatedAt: "2019-08-26T13:02:31:000Z"
        }],
        tasklistTemplates: [{
          id: 1,
          name: "Default Tasklist",
          position: 0,
          tasks: [{
            id: 1,
            description: "Test",
            guidance: "test",
            key: "new-test-task",
            actionType: "",
            actionDefinition: ""
          }]
        }],
        teams: []
      }
      ]
    },
    preferences: {
      dateFormat: "Do MMM YYYY",
      dateTimeFormat: "HH:mm, Do MMM YYYY",
      pageSize: 10,
      timeline: {
        conversations: true,
        created: true,
        documents: true,
        participants: true,
        stateChanges: true,
        tasks: true,
        updates: true,
        viewed: true
      }
    },

    recentCases: [{
      id: 1,
      title: "TestCase 001",
      currentState: "Active",
      caseTypeId: 1,
      caseType: "Online order",
      sla: "2 SLA’s - 1 in breach",
      slaState: "breach"
    },
    {
      id: 2,
      title: "FakeCase-123",
      currentState: "Testing",
      caseTypeId: 1,
      caseType: "Order",
      sla: "1 SLA in breach",
      slaState: "breach"
    },
    {
      id: 3,
      title: "FakeCase-125",
      currentState: "Testing",
      caseTypeId: 1,
      caseType: "Claim",
      sla: ""
    },
    {
      id: 4,
      title: "FakeCase-128",
      currentState: "Testing",
      caseTypeId: 1,
      caseType: "Customer",
      sla: "1 SLA"
    },
    {
      id: 8,
      title: "TestCase 003",
      currentState: "Testing",
      caseTypeId: 1,
      caseType: "Order",
      sla: "2 SLA’s - 1 in breach",
      slaState: "breach"
    },
    {
      id: 9,
      title: "TestCase 004",
      currentState: "Testing",
      caseTypeId: 1,
      caseType: "Enquiry",
      sla: "2 SLA’s - 1 in jeopardy",
      slaState: "jeopardy"
    }
    ],
    assignedTasks: [{
      id: 1,
      name: "Test Task 001",
      description: "An Example Task",
      templated: true,
      scheduledType: "At",
      scheduledTime: new Date().setHours(new Date().getHours() - 36),
      actionType: "ManualTask",
      assignedToTeam: {
        id: 1,
        displayName: "Team01"
      },
      assignedToUser: {
        id: 2,
        displayName: "Test User"
      },
      case: {
        id: 1,
        title: "FakeCase-001",
        caseTypeId: 1
      }
    },
    {
      id: 2,
      name: "Test Task 002",
      description: "An Example Task",
      templated: true,
      scheduledType: "By",
      scheduledTime: new Date().setHours(new Date().getHours() - 2),
      actionType: "ManualTask",
      assignedToTeam: {
        id: 1,
        displayName: "Team01"
      },
      assignedToUser: {
        id: 2,
        displayName: "Test User"
      },
      case: {
        id: 1,
        title: "FakeCase-001",
        caseTypeId: 1
      }
    },
    {
      id: 3,
      name: "Test Task 003",
      description: "An Example Task",
      templated: true,
      scheduledType: "At",
      scheduledTime: new Date().setHours(new Date().getHours() + 78),
      actionType: "ManualTask",
      assignedToTeam: {
        id: 1,
        displayName: "Team01"
      },
      case: {
        id: 1,
        title: "FakeCase-001",
        caseTypeId: 1
      }
    },
    {
      id: 4,
      name: "Test Task 004",
      description: "An Example Task",
      templated: true,
      scheduledType: "By",
      scheduledTime: new Date().setHours(new Date().getHours() + 1),
      actionType: "AutomaticTask",
      assignedToTeam: {
        id: 1,
        displayName: "Team01"
      },
      case: {
        id: 1,
        title: "FakeCase-001",
        caseTypeId: 1
      }
    },
    {
      id: 5,
      name: "Test Task 005",
      description: "An Example Task",
      templated: true,
      scheduledType: "At",
      scheduledTime: new Date().setHours(new Date().getHours() + 48),
      actionType: "ManualTask",
      case: {
        id: 1,
        title: "FakeCase-001",
        caseTypeId: 1
      }
    },
    {
      id: 6,
      name: "Test Task 006",
      description: "An Example Task",
      templated: false,
      actionType: "ManualTask",
      case: {
        id: 1,
        title: "FakeCase-001",
        caseTypeId: 1
      }
    }
    ],
    flaggedBuckets: []
  }
}
